import React, { useContext, useState, useEffect } from 'react';
import {
  ButtonBase,
  Typography,
  Paper,
  Dialog,
  TextField,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core';
import { observer } from 'mobx-react-lite';

import { InputContainer } from './styles';
import { Button } from '../../generators/FormGenerator/styles';
import { XYTCredentialInput } from '../../store/inputs/XYTCredentialInput';
import { instance } from '../../services/api';
import { GlobalsContext } from '../../store/Globals';

const CXYTCredentialInput = observer(
  ({ item }: { item: XYTCredentialInput }) => {
    const globals = useContext(GlobalsContext);
    const [openDialog, setOpenDialog] = useState(false);
    const [scanServer, setScanServer] = useState(globals.fingerprintServer.url);
    const [portScanServer, setPortScanServer] = useState(
      globals.fingerprintServer.port,
    );
    const [xytValue, setXytValue] = useState<Record<string, any> | null>(null);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const { value, onChange, tag } = item;

    useEffect(() => {
      if (!value) setXytValue(null);
    }, [value]);

    const getMinFile = () => {
      setLoading(true);
      instance
        .get(`${scanServer}:${portScanServer}/getminfile`)
        .then((res) => {
          setLoading(false);
          setXytValue(res.data ? res.data : null);
          onChange(res.data ? res.data : null);
          setOpenDialog(false);
          setErrorMsg('');
        })
        .catch((err) => {
          setLoading(false);
          setXytValue(null);
          onChange(null);
          try {
            setErrorMsg(err.response.data);
          } catch {
            setErrorMsg(err && err.message ? err.message : 'Live scan failed');
          }
        });
    };

    return (
      <div>
        <Dialog open={openDialog}>
          <DialogTitle id="form-dialog-title">
            Fingerprint livescan server
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              fullWidth
              margin="dense"
              id="scanserver"
              value={scanServer}
              disabled={loading}
              label="Live scan server"
              onChange={(e) => setScanServer(e.target.value)}
            />
            <TextField
              fullWidth
              id="port"
              label="Port"
              margin="dense"
              type="numeric"
              disabled={loading}
              value={portScanServer}
              onChange={(e) => setPortScanServer(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              onClick={() => {
                setXytValue(null);
                onChange(null);
                globals.setFingerprintServer(scanServer, portScanServer);
                setOpenDialog(false);
              }}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
        <Paper elevation={3}>
          <InputContainer>
            <div style={{ marginTop: '2%' }}>
              <TextField
                fullWidth
                id={tag}
                label=""
                placeholder="Live scan"
                style={{ marginTop: '2%' }}
                value={xytValue ? xytValue.xytData : ''}
                onChange={(e) => {
                  setXytValue({ xytData: e.target.value });
                  onChange({ xytData: e.target.value });
                }}
              />
            </div>
            {loading ? (
              <CircularProgress style={{ marginTop: '2%' }} />
            ) : (
              <div>
                <Button
                  style={{ marginTop: '1%' }}
                  onClick={() => getMinFile()}
                >
                  Live Scan
                </Button>
                <ButtonBase
                  style={{ marginLeft: '5%' }}
                  onClick={() => setOpenDialog(true)}
                >
                  <i className="bx bx-cog" style={{ fontSize: '24px' }}></i>
                  <Typography gutterBottom color="error">
                    {errorMsg}
                  </Typography>
                </ButtonBase>
              </div>
            )}
          </InputContainer>
        </Paper>
      </div>
    );
  },
);

export default CXYTCredentialInput;
